/* eslint-disable */
import * as util from "@/api/omniwa";

const state = {
    detailBroadcast: {},
    broadcastParamSt: { //from state
        is_custom_url: false,
        rowDetail: {},
        is_duplicate: false,
        broadcast_id: '',
        title: "",
        provider: "whatsapp",
        license_id: '',
        to_group: [],
        to: [],
        is_group: 1, //for group set 1, for personal set 0
        is_group_type: "group", //group/tags
        message: {
            text: "",
            message_type: "text", //text,image,document
            file_url: ""
        },
        sending_options: 1,
        sending_schedule: "",
        is_recurring: 0,
        recurring_form: {
            recurrence: "",
            recurrence_time: "00:01",
            recurrence_every: "",
            recurrence_annually_month: "",
            recurrence_end: "never",
            recurrence_end_date: ""
        },
        is_send: 1,
        to_test: "",
        footer_message_status: false,
        footer_message: "",
        buttons: ["", "", "", "", "", "", "", "", "", ""]

    },
    messageTypeOptionsUpload: ["image", "document"],
    messageTypeCurrent: "image",
    sendText: {
        recipient_number: "",
        text: "",
        quoted_id: "",
        quoted_message: ""
    },
    onlyUploadFile: {
        files: null,
        message_type: ""
    },
    objFilesMessageHandler: {
        recipient_number: "",
        id: "",
        text: "",
        quoted_id: "",
        quoted_message: "",
        // message_media: messaegMedia,
        message_type: ""
    }
};


const mutations = {
    SET_detailBroadcast: (state, value) => {
        state.detailBroadcast = value
    },
    SET_broadcastParamSt: (state, value) => {
        state.broadcastParamSt = value
    },
    SET_objFilesMessageHandler: (state, value) => {
        state.objFilesMessageHandler = value
    },
    SET_messageTypeCurrent: (state, value) => {
        state.messageTypeCurrent = value
    },
    SET_sendText: (state, value) => {
        state.sendText = value
    },
    SET_onlyUploadFile: (state, value) => {
        state.onlyUploadFile = value
    },
};

const actions = {
   
    isOnline({ commit }, phone) {
        return new Promise((resolve, reject) => {
            util.isOnline(phone).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/omniwa.js